var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3182FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8194 21.6838V27.1999C27.8194 27.3354 27.7032 27.4516 27.5677 27.4516H24.7226C24.5871 27.4516 24.471 27.3354 24.471 27.1999V22.0709C24.471 20.7161 23.9871 19.787 22.7677 19.787C21.8387 19.787 21.2968 20.4064 21.0452 21.0064C20.9484 21.2193 20.929 21.529 20.929 21.8193V27.1999C20.929 27.3354 20.8129 27.4516 20.6774 27.4516H17.8516C17.7161 27.4516 17.6 27.3354 17.6 27.1999C17.6 25.8258 17.6387 19.187 17.6 17.6387C17.6 17.5032 17.7161 17.387 17.8516 17.387H20.6968C20.8323 17.387 20.9484 17.5032 20.9484 17.6387V18.8193C20.9484 18.8387 20.929 18.8387 20.929 18.858H20.9484V18.8193C21.3936 18.1419 22.1871 17.1548 23.9677 17.1548C26.1742 17.1548 27.8194 18.6064 27.8194 21.6838ZM12.6452 27.4709H15.4903C15.6258 27.4709 15.7419 27.3548 15.7419 27.2193V17.6387C15.7419 17.5032 15.6258 17.387 15.4903 17.387H12.6452C12.5097 17.387 12.3936 17.5032 12.3936 17.6387V27.2193C12.4129 27.3548 12.5097 27.4709 12.6452 27.4709Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9807 16.1291C14.9748 16.1291 15.7807 15.3232 15.7807 14.3291C15.7807 13.3349 14.9748 12.5291 13.9807 12.5291C12.9866 12.5291 12.1807 13.3349 12.1807 14.3291C12.1807 15.3232 12.9866 16.1291 13.9807 16.1291Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSocialMedia);
export default __webpack_public_path__ + "static/media/linkedinSocialMedia.fee5f6ea55a51771f92b6e2333ba4f3c.svg";
export { ForwardRef as ReactComponent };